<template>
  <div class="home">
    <!-- 侧边导航 -->
    <div class="sideNav">
      <div class="zhao">
        <span>招</span>
        <div class="showZhao">
          <p>
            您好，欢迎您咨询了解北京燕京实验中学，具体招生详情请联系升学顾问，如有访校需求请您直接扫访校码填写相关信息进行预约。
          </p>
          <div class="tuBox">
            <img
              src="https://www.yjsyzx.com/images/78aa4227-ea12-48ca-bafc-90e5b261608a.png"
              alt=""
            />
            <img
              src="https://www.yjsyzx.com/images/4d24e162-e7e2-4897-8a72-dbcbb47fa03b.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="ren">
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/people.png"
          alt=""
          class="imgpeople"
        />

        <div class="schoolMa">
          <img
            src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/erweima.jpg"
            alt=""
          />
          <p>学校公众号</p>
        </div>
      </div>
      <div class="dianhua">
        <img
          src="https://www.yjsyzx.com/images/fd37f35a-2471-429a-bb0a-98afaafe04ab.png"
          alt=""
        />
        <div class="sideLianxi">
          <p>咨询电话</p>
          <p>工作时间: 9:00-18:00</p>
          <p>热线电话1:010-57530666</p>
          <p>热线电话2:010-57530655</p>
        </div>
      </div>

      <div class="gotop" @click="goTop">TOP</div>
    </div>
    <div class="top1">
      <img
        src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/top1.png"
        alt=""
      />
    </div>
    <div class="searchBox">
      <div class="searchMain">
        <div class="leftMian" @click="toHome">
          <img
            src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/logo.png"
            alt=""
          />
          <div class="title">
            <div class="titleTop">北京市朝阳区燕京实验中学</div>
            <div class="titleBtm">BEJING YANJING EXPERIMENTAL HIGH SCHOOL</div>
          </div>
        </div>
        <div class="rightMian">
          <div class="shuzi" @click="toZhongtai">数字校园 <span> ></span></div>
          <div class="sousuo">
            <el-input
              v-model="search"
              placeholder="搜索"
              @keyup.enter.native="handleEnter"
            ></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="nav">
      <ul>
        <li
          v-for="(item, index) in oneList"
          :key="index"
          v-on:mouseenter="getTitle(item.id, index)"
          v-on:mouseleave="resetTitle"
        >
          <div
            :class="
              item.title == navTitle ? 'liTitle liTitleActive' : 'liTitle'
            "
            @click="toHome1(item.title)"
          >
            {{ item.title }}
          </div>
          <span :class="item.title == navTitle ? 'lineActive' : ''"></span>
          <div class="dropDown" v-if="twoList.length > 0">
            <div
              class="dropDownItem"
              v-for="(two, index) in twoList"
              v-if="item.id == two.oneId"
              @click="toSkip(two)"
            >
              {{ two.title }}
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- ----------------------- -->
    <div class="mobile">
      <nav class="navHomeLine">
        <div class="leftLogo">
          <!-- <router-link to="/"> -->
          <div class="logo" @click="toHome">
            <img
              src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/mobiletu.png"
              alt=""
            />
          </div>
          <!-- </router-link> -->
        </div>
        <div class="rightLogo">
          <div class="navImg">
            <img
              src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/sangang.png"
              alt=""
              @click="mobileNavClick"
            />
          </div>
        </div>
      </nav>
      <div class="menuBox" v-if="mobileNavShow">
        <div
          class="menuItem"
          v-for="(item, index) in oneList"
          :key="index"
          @click="ShowMenu(item.id, index)"
        >
          <div class="first" @click="toHome1(item.title)">
            <span>{{ item.title }} </span> <i class="el-icon-arrow-down"></i>
          </div>

          <!-- 展开二级菜单内容 -->
          <div class="ShowData" v-if="item.isShowMenu">
            <div
              v-for="(two, index) in twoList"
              @click="toSkip(two)"
              class="erjiMobile"
            >
              {{ two.title }}
            </div>
          </div>
        </div>
        <div class="menuItem" @click="toZhongtai">数字校园</div>
      </div>
    </div>
    <!-- ------------------------- -->
    <img :src="banner" alt="" class="bannerImg" v-if="isShow" />
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      navTitle: "首页",
      // 导航搜索
      search: "",
      oneList: [],
      twoList: [],
      banner: "",
      isShow: true,
      mobileNavShow: false,
    };
  },
  created() {},

  beforeRouteLeave(to, from, next) {
    this.mounted();
    next();
  },
  mounted() {
    if (this.$route.path == "/") {
      this.isShow = false;
      sessionStorage.setItem("navTitle", "首页");
    } else {
      this.isShow = true;

      if (
        this.$route.path == "/xxjj" ||
        this.$route.path == "/bxlj" ||
        this.$route.path == "/xyhj"
      ) {
        sessionStorage.setItem("navTitle", "学校概况");
      } else if (
        this.$route.path == "/xxyw" ||
        this.$route.path == "/mtjj" ||
        this.$route.path == "/spzq" ||
        this.$route.path == "/mtjjDetail" ||
        this.$route.path == "/xwxq"
      ) {
        sessionStorage.setItem("navTitle", "新闻动态");
      } else if (
        this.$route.path == "/zzjs" ||
        this.$route.path == "/dyhd" ||
        this.$route.path == "/dyhdDetail" ||
        this.$route.path == "/zzjsDetail"
      ) {
        sessionStorage.setItem("navTitle", "党建工作");
      } else if (
        // this.$route.path == "/xxgw" ||

        this.$route.path == "/tdgl" ||
        this.$route.path == "/gwxq"
      ) {
        sessionStorage.setItem("navTitle", "管理团队");
      } else if (
        this.$route.path == "/jscy" ||
        this.$route.path == "/jsdb" ||
        this.$route.path == "/jsDetail" ||
        this.$route.path == "/jsfz" ||
        this.$route.path == "/jshd" ||
        this.$route.path == "/jshdDetail" ||
        this.$route.path == "/jsry" ||
        this.$route.path == "/jsryDetail" ||
        this.$route.path == "/sksp" ||
        this.$route.path == "/keyan" ||
        this.$route.path == "/keyandetail"
      ) {
        sessionStorage.setItem("navTitle", "教师风采");
      } else if (
        this.$route.path == "/czkc" ||
        this.$route.path == "/gzkc" ||
        this.$route.path == "/xxkc" ||
        this.$route.path == "/shuangyu" ||
        this.$route.path == "/yishu" ||
        this.$route.path == "/meishu"
      ) {
        sessionStorage.setItem("navTitle", "课程简介");
      } else if (
        this.$route.path == "/xszp" ||
        this.$route.path == "/xyhd" ||
        this.$route.path == "/huojiang" ||
        this.$route.path == "/gongyu"
      ) {
        sessionStorage.setItem("navTitle", "学生活动");
      } else if (
        this.$route.path == "/gjxm" ||
        this.$route.path == "/gjxmDetail" ||
        this.$route.path == "/jlhf" ||
        this.$route.path == "/jlhfDetail"
      ) {
        sessionStorage.setItem("navTitle", "国际交流");
      } else if (
        this.$route.path == "/cfxy" ||
        this.$route.path == "/cfxyDetail" ||
        this.$route.path == "/csg" ||
        this.$route.path == "/csgDetail" ||
        this.$route.path == "/lxfs" ||
        this.$route.path == "/xsc" ||
        this.$route.path == "/xscDetail" ||
        this.$route.path == "/xyhdbm" ||
        this.$route.path == "/xyhdbmDetail" ||
        this.$route.path == "/zx" ||
        this.$route.path == "/zxDetail" ||
        this.$route.path == "/ysx" ||
        this.$route.path == "/ysxdetail"
      ) {
        sessionStorage.setItem("navTitle", "招生报名");
      } else if (
        this.$route.path == "/gwxq1" ||
        this.$route.path == "/zpjz" ||
        this.$route.path == "/zpjzDetail"
      ) {
        sessionStorage.setItem("navTitle", "加入我们");
      }
    }
    if (sessionStorage.getItem("navTitle") == null) {
      this.navTitle = "首页";
    } else {
      this.navTitle = sessionStorage.getItem("navTitle");
      if (this.navTitle == "首页") {
      } else {
        this.api.sideBanner({ type: this.navTitle }).then((res) => {
          this.banner = res.data.img;
        });
      }
    }
    this.api.navOne({}).then((res) => {
      this.oneList = res.data;
      this.oneList.forEach((item) => {
        item.isShowMenu = false;
      });
    });
  },
  methods: {
    ShowMenu(id, currentIndex) {
      this.api.navTwo({ id }).then((res) => {
        this.twoList = res.data;
      });
      //请求接口获取二级菜单
      this.oneList.forEach((item, index) => {
        if (currentIndex == index) {
          item.isShowMenu = !item.isShowMenu;
        } else {
          item.isShowMenu = false;
        }
      });
      this.$forceUpdate();
    },
    // 移动端点击
    mobileNavClick() {
      if (this.mobileNavShow == true) {
        this.mobileNavShow = false;
      } else {
        this.mobileNavShow = true;
      }
    },
    toZhongtai() {
      window.open("http://60.247.2.76:8088");
    },
    handleEnter() {
      console.log(sessionStorage.getItem("navTitle"));
      if (sessionStorage.getItem("navTitle") == "新闻动态") {
        this.$router.push({
          path: "xxyw",
          query: { search: this.search },
        });
        location.reload();
      } else {
        this.$router.push({
          path: "xxyw",
          query: { search: this.search },
        });
        sessionStorage.setItem("navTitle", "新闻动态");
      }
    },
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动效果
      });
    },
    toSkip(e) {
      // this.navTitle = e.onTitle;
      sessionStorage.setItem("navTitle", e.onTitle);
      // console.log(this.navTitle);
      if (e.title == "学校简介") {
        this.$router.push("/xxjj");
      } else if (e.title == "办学理念") {
        this.$router.push("/bxlj");
      } else if (e.title == "校园环境") {
        this.$router.push("/xyhj");
      } else if (e.title == "学校要闻") {
        this.$router.push("/xxyw");
      } else if (e.title == "媒体聚焦") {
        this.$router.push("/mtjj");
      } else if (e.title == "视频专区") {
        this.$router.push("/spzq");
      } else if (e.title == "组织建设") {
        this.$router.push("/zzjs");
      } else if (e.title == "党员活动") {
        this.$router.push("/dyhd");
      } else if (e.title == "学校顾问") {
        this.$router.push("/xxgw");
      } else if (e.title == "管理团队") {
        this.$router.push("/tdgl");
      } else if (e.title == "教师代表") {
        this.$router.push("/jsdb");
      } else if (e.title == "教师活动") {
        this.$router.push("/jshd");
      } else if (e.title == "教师荣誉") {
        this.$router.push("/jsry");
      } else if (e.title == "教师发展") {
        this.$router.push("/jsfz");
      } else if (e.title == "授课视频") {
        this.$router.push("/sksp");
      } else if (e.title == "教师才艺") {
        this.$router.push("/jscy");
      } else if (e.title == "教育科研") {
        this.$router.push("/keyan");
      } else if (e.title == "小学课程") {
        this.$router.push("/xxkc");
      } else if (e.title == "初中课程") {
        this.$router.push("/czkc");
      } else if (e.title == "高中课程") {
        this.$router.push("/gzkc");
      } else if (e.title == "双语融合课程") {
        this.$router.push("/shuangyu");
      } else if (e.title == "美术特色课程") {
        this.$router.push("/meishu");
      } else if (e.title == "艺术特色班课程") {
        this.$router.push("/yishu");
      } else if (e.title == "校园活动") {
        this.$router.push("/xyhd");
      } else if (e.title == "学生作品") {
        this.$router.push("/xszp");
      } else if (e.title == "交流互访") {
        this.$router.push("/jlhf");
      } else if (e.title == "国际项目") {
        this.$router.push("/gjxm");
      } else if (e.title == "联系方式") {
        this.$router.push("/lxfs");
      } else if (e.title == "小升初报名") {
        this.$router.push("/xsc");
      } else if (e.title == "初升高报名") {
        this.$router.push("/csg");
      } else if (e.title == "转学报名") {
        this.$router.push("/zx");
      } else if (e.title == "招生简章") {
        this.$router.push("/xyhdbm");
      } else if (e.title == "参访校园报名") {
        this.$router.push("/cfxy");
      } else if (e.title == "幼升小报名") {
        this.$router.push("/ysx");
      } else if (e.title == "招聘简章") {
        this.$router.push("/zpjz");
      } else if (e.title == "岗位需求") {
        this.$router.push("/gwxq1");
      } else if (e.title == "校车服务") {
        this.$router.push("/xiaoche");
      } else if (e.title == "学生住宿") {
        this.$router.push("/zhusu");
      } else if (e.title == "学生餐饮") {
        this.$router.push("/canyin");
      } else if (e.title == "学生校服") {
        this.$router.push("/xiaofu");
      } else if (e.title == "家校共育") {
        this.$router.push("/gongyu");
      }
    },

    toHome() {
      sessionStorage.setItem("navTitle", "首页");
      this.$router.push("/");
    },
    toHome1(e) {
      if (e == "首页") {
        sessionStorage.setItem("navTitle", "首页");
        this.$router.push("/");
      }
    },

    getTitle(e, index) {
      this.api.navTwo({ id: e }).then((res) => {
        this.twoList = res.data;
      });
    },

    resetTitle() {
      this.twoList = [];
    },
  },
};
</script>
<style scoped>
.mobile {
  display: none;
}
.top1 {
  width: 100%;
  height: 55px;
}
.top1 img {
  width: 100%;
  height: 100%;
  font-size: 0;
}

.searchBox {
  width: 100%;
  height: 144px;
  /* 网站主色 */
  background: rgb(152, 33, 35);
}

.searchMain {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.leftMian {
  width: 800px;
  height: 100%;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.leftMian img {
  width: 100px;
  height: 100px;
  display: block;
  margin-top: 22px;
}
.title {
  width: 690px;
  height: 100%;
}

.titleTop {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 32px;
  font-weight: 700;
  line-height: 46px;
  letter-spacing: 0px;
  text-align: left;
  margin-top: 40px;
}
.titleBtm {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 20px;
  font-weight: 400;
  line-height: 29px;
  letter-spacing: 0px;
  text-align: left;
}

.rightMian {
  width: 400px;
  height: 100%;
  display: flex;
  justify-content: space-around;
}
.shuzi {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 21.33px;
  font-weight: 400;
  line-height: 31px;
  letter-spacing: 0%;
  text-align: left;
  line-height: 144px;
  cursor: pointer;
}

.sousuo {
  width: 200px;
  height: 60px;
  margin-top: 46px;
}
.sousuo /deep/.el-input__inner {
  width: 190px;
  height: 52px;
  box-sizing: border-box;
  border: 1.33px solid rgb(168, 18, 18);
  border-radius: 106px;
  background: rgb(255, 255, 255);
}

.sousuo /deep/.el-input__inner::placeholder {
  /* WebKit browsers，webkit内核浏览器 */
  color: rgb(189, 189, 189);
  font-family: 思源黑体;
  font-size: 18.67px;
  font-weight: 300;
  line-height: 27px;
  letter-spacing: 0%;
  text-align: left;
}
.nav {
  width: 100%;
  height: 80px;
  background: rgb(255, 255, 255);
  display: block;
}
ul {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
  list-style: none;
  display: flex;
  justify-content: space-around;
}

ul li {
  width: 118px;
  height: 80px;
  cursor: pointer;
  position: relative;
}

.liTitle {
  width: 118px;
  color: rgb(116, 117, 130);
  font-family: 思源黑体;
  font-size: 18px;
  font-weight: 400;
  line-height: 80px;
  letter-spacing: 0%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.liTitleActive {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 18px;
  font-weight: 400;
}
/* .el-icon-arrow-down {
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
} */

.dropDown {
  width: 118px;
  position: absolute;
  top: 80px;
  left: 0px;
  z-index: 9999 !important;
  background: rgba(152, 33, 35, 0.8);
}

.dropDownItem {
  width: 118px;
  height: 40px;
  color: rgb(255, 255, 255);
  font-family: 微软雅黑;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
}

.dropDownItem:hover {
  width: 118px;
  height: 40px;
  color: rgb(152, 33, 35);
  font-family: 微软雅黑;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
  background: rgb(255, 255, 255);
}

.lineActive {
  width: 34px;
  height: 5px;
  border-radius: 6px;
  background: rgb(152, 33, 35);
  display: block;
  margin: 0 auto;
  margin-top: -20px;
}

.bannerImg {
  width: 100%;
  height: 380px;
}

/* 侧边导航 */
.sideNav {
  width: 60px;
  height: 220px;
  position: fixed;
  right: 0;
  bottom: 80px;
  z-index: 99999;
}
.ren {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  /* 侧边栏未选中颜色 */
  background: rgb(196, 196, 196);
  position: relative;
  cursor: pointer;
}

.ren .imgpeople {
  width: 35px;
  height: 40px;
  position: absolute;
  left: 15px;
  top: 13px;
}
.schoolMa {
  width: 110px;
  height: 144.63px;
  position: absolute;
  left: -120px;
  top: 0;
  border-radius: 6.15px;
  /* 网站主色 */
  background: rgb(152, 33, 35);
  display: none;
}
.schoolMa img {
  width: 90px;
  height: 90px;
  position: absolute;
  top: 10px;
  left: 10px;
}
.schoolMa p {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 14.29px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  position: absolute;
  bottom: 15px;
  left: 18px;
  text-align: center;
}
.ren:hover .schoolMa {
  display: block;
}
.dianhua {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  /* 侧边栏未选中颜色 */
  background: rgb(196, 196, 196);
  position: relative;
  cursor: pointer;
}
.gotop {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  /* 侧边栏未选中颜色 */
  background: rgb(196, 196, 196);
  position: relative;
  color: rgb(246, 245, 248);
  font-family: 思源黑体;
  font-size: 21.1px;
  font-weight: 500;
  line-height: 65px;
  letter-spacing: -2%;
  text-align: center;
  cursor: pointer;
}
.zhao {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  /* 侧边栏未选中颜色 */
  background: rgb(196, 196, 196);
  position: relative;
  color: rgb(246, 245, 248);
  font-family: 思源黑体;
  font-size: 35px;
  font-weight: 500;
  line-height: 65px;
  letter-spacing: -2%;
  text-align: center;
  cursor: pointer;
}
.dianhua img {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 13px;
  top: 13px;
}
.ren:hover,
.dianhua:hover,
.gotop:hover,
.zhao:hover {
  /* 网站主色 */
  background: rgb(152, 33, 35);
}

.sideLianxi {
  width: 150.38px;
  height: 92.83px;
  padding: 10px 15px;
  border-radius: 6.33px;
  /* 网站主色 */
  background: rgb(152, 33, 35);
  position: absolute;
  left: -190px;
  top: 0;
  display: none;
}
.sideLianxi p {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 12px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: left;
}
.sideLianxi p:first-child {
  font-size: 14px;
  margin-bottom: 10px;
}
.dianhua:hover .sideLianxi {
  display: block;
}
.showZhao {
  width: 210px;
  height: 190px;
  position: absolute;
  left: -220px;
  top: -30px;
  border-radius: 6.15px;
  /* 网站主色 */
  background: rgb(152, 33, 35);
  display: none;
}
.showZhao p {
  width: 95%;
  color: white;
  margin: 10px auto;
  font-size: 13px;
  line-height: 20px;
}

.tuBox {
  width: 90%;
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
}
.tuBox img {
  width: 80px;
  height: 80px;
  background: white;
}

.zhao:hover .showZhao {
  display: block;
}

/* 未修改 */

@media screen and (max-width: 1440px) {
  .top1 {
    width: 100%;
    height: 55px;
  }
  .top1 img {
    width: 100%;
    height: 100%;
    font-size: 0;
  }

  .searchBox {
    width: 100%;
    height: 144px;
    /* 网站主色 */
    background: rgb(152, 33, 35);
  }

  .searchMain {
    width: 1000px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .leftMian {
    width: 600px;
    height: 100%;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
  }
  .leftMian img {
    width: 100px;
    height: 100px;
    display: block;
    margin-top: 22px;
  }
  .title {
    height: 100%;
  }

  .titleTop {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 32px;
    font-weight: 700;
    line-height: 46px;
    letter-spacing: 0px;
    text-align: left;
    margin-top: 40px;
  }
  .titleBtm {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 20px;
    font-weight: 400;
    line-height: 29px;
    letter-spacing: 0px;
    text-align: left;
  }

  .rightMian {
    width: 400px;
    height: 100%;
    display: flex;
    justify-content: space-around;
  }
  .shuzi {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 21.33px;
    font-weight: 400;
    line-height: 31px;
    letter-spacing: 0%;
    text-align: left;
    line-height: 144px;
    cursor: pointer;
  }

  .sousuo {
    width: 200px;
    height: 60px;
    margin-top: 46px;
  }
  .sousuo /deep/.el-input__inner {
    width: 190px;
    height: 52px;
    box-sizing: border-box;
    border: 1.33px solid rgb(168, 18, 18);
    border-radius: 106px;
    background: rgb(255, 255, 255);
  }

  .sousuo /deep/.el-input__inner::placeholder {
    /* WebKit browsers，webkit内核浏览器 */
    color: rgb(189, 189, 189);
    font-family: 思源黑体;
    font-size: 18.67px;
    font-weight: 300;
    line-height: 27px;
    letter-spacing: 0%;
    text-align: left;
  }
  .nav {
    width: 100%;
    height: 80px;
    background: rgb(255, 255, 255);
  }
  /* ul {
    width: 1000px;
    height: 80px;
    margin: 0 auto;
    list-style: none;
    display: flex;
    justify-content: space-around;
  } */

  /* ul li {
    width: 90px;
    height: 80px;
    cursor: pointer;
    position: relative;
  } */

  .liTitle {
    width: 90px;
    color: rgb(116, 117, 130);
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: 400;
    line-height: 80px;
    letter-spacing: 0%;
    text-align: center;
  }

  .liTitleActive {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-size: 18px;
    font-weight: 400;
  }
  /* .el-icon-arrow-down {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
  } */

  .dropDown {
    width: 90px;
    position: absolute;
    top: 80px;
    left: 0px;
    z-index: 9999 !important;
    background: rgba(152, 33, 35, 0.8);
  }

  .dropDownItem {
    width: 90px;
    height: 40px;
    color: rgb(255, 255, 255);
    font-family: 微软雅黑;
    font-size: 14px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
  }

  .dropDownItem:hover {
    width: 90px;
    height: 40px;
    color: rgb(152, 33, 35);
    font-family: 微软雅黑;
    font-size: 14px;
    font-weight: 400;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
    background: rgb(255, 255, 255);
  }

  .lineActive {
    width: 34px;
    height: 5px;
    border-radius: 6px;
    background: rgb(152, 33, 35);
    display: block;
    margin: 0 auto;
    margin-top: -20px;
  }

  .bannerImg {
    width: 100%;
    height: 380px;
  }

  /* 侧边导航 */
  .sideNav {
    width: 60px;
    height: 220px;
    position: fixed;
    right: 0;
    bottom: 80px;
    z-index: 99999;
  }
  .ren {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    /* 侧边栏未选中颜色 */
    background: rgb(196, 196, 196);
    position: relative;
    cursor: pointer;
  }

  .ren .imgpeople {
    width: 35px;
    height: 40px;
    position: absolute;
    left: 15px;
    top: 13px;
  }
  .schoolMa {
    width: 110px;
    height: 144.63px;
    position: absolute;
    left: -120px;
    top: 0;
    border-radius: 6.15px;
    /* 网站主色 */
    background: rgb(152, 33, 35);
    display: none;
  }
  .schoolMa img {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .schoolMa p {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 14.29px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0px;
    position: absolute;
    bottom: 15px;
    left: 18px;
    text-align: center;
  }
  .ren:hover .schoolMa {
    display: block;
  }
  .dianhua {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    /* 侧边栏未选中颜色 */
    background: rgb(196, 196, 196);
    position: relative;
    cursor: pointer;
  }
  .gotop {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    /* 侧边栏未选中颜色 */
    background: rgb(196, 196, 196);
    position: relative;
    color: rgb(246, 245, 248);
    font-family: 思源黑体;
    font-size: 21.1px;
    font-weight: 500;
    line-height: 65px;
    letter-spacing: -2%;
    text-align: center;
    cursor: pointer;
  }
  .dianhua img {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 13px;
    top: 13px;
  }
  .ren:hover,
  .dianhua:hover,
  .gotop:hover {
    /* 网站主色 */
    background: rgb(152, 33, 35);
  }

  .sideLianxi {
    width: 150.38px;
    height: 92.83px;
    padding: 10px 15px;
    border-radius: 6.33px;
    /* 网站主色 */
    background: rgb(152, 33, 35);
    position: absolute;
    left: -190px;
    top: 0;
    display: none;
  }
  .sideLianxi p {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0px;
    text-align: left;
  }
  .sideLianxi p:first-child {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .dianhua:hover .sideLianxi {
    display: block;
  }
}

@media screen and (max-width: 450px) {
  .top1 {
    width: 100%;
    height: 25px;
  }
  .top1 img {
    width: 100%;
    height: 100%;
    font-size: 0;
  }
  .searchBox,
  .nav {
    display: none;
  }

  .bannerImg {
    width: 100%;
    height: 180px;
  }

  /* 侧边导航 */
  .sideNav {
    width: 60px;
    height: 220px;
    position: fixed;
    right: 0;
    bottom: 80px;
    z-index: 99999;
  }
  .ren {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    /* 侧边栏未选中颜色 */
    background: rgb(196, 196, 196);
    position: relative;
    cursor: pointer;
  }

  .ren .imgpeople {
    width: 35px;
    height: 40px;
    position: absolute;
    left: 15px;
    top: 13px;
  }
  .schoolMa {
    width: 110px;
    height: 144.63px;
    position: absolute;
    left: -120px;
    top: 0;
    border-radius: 6.15px;
    /* 网站主色 */
    background: rgb(152, 33, 35);
    display: none;
  }
  .schoolMa img {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  .schoolMa p {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 14.29px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0px;
    position: absolute;
    bottom: 15px;
    left: 18px;
    text-align: center;
  }
  .ren:hover .schoolMa {
    display: block;
  }
  .dianhua {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    /* 侧边栏未选中颜色 */
    background: rgb(196, 196, 196);
    position: relative;
    cursor: pointer;
  }
  .gotop {
    width: 65px;
    height: 65px;
    border-radius: 50%;
    /* 侧边栏未选中颜色 */
    background: rgb(196, 196, 196);
    position: relative;
    color: rgb(246, 245, 248);
    font-family: 思源黑体;
    font-size: 21.1px;
    font-weight: 500;
    line-height: 65px;
    letter-spacing: -2%;
    text-align: center;
    cursor: pointer;
  }
  .dianhua img {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 13px;
    top: 13px;
  }
  .ren:hover,
  .dianhua:hover,
  .gotop:hover {
    /* 网站主色 */
    background: rgb(152, 33, 35);
  }

  .sideLianxi {
    width: 150.38px;
    height: 92.83px;
    padding: 10px 15px;
    border-radius: 6.33px;
    /* 网站主色 */
    background: rgb(152, 33, 35);
    position: absolute;
    left: -190px;
    top: 0;
    display: none;
  }
  .sideLianxi p {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0px;
    text-align: left;
  }
  .sideLianxi p:first-child {
    font-size: 14px;
    margin-bottom: 10px;
  }
  .dianhua:hover .sideLianxi {
    display: block;
  }

  /* ************************************** */
  .mobile {
    display: block;
    background: rgb(152, 33, 35);
  }

  .navHomeLine {
    height: 60px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .logo {
    width: 207px;
    height: 42px;
  }
  .logo img {
    width: 100%;
    height: 100%;
  }
  .rightLogo img {
    width: 28px;
    height: 28px;
  }

  .menuBox {
    width: 375px;
    list-style: none;
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    background: #fff;
  }
  .menuBox .menuItem {
    padding: 10px 20px;
  }
  .menuBox .menuItem .first {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .erjiMobile {
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: rgb(59, 58, 58);
    font-size: 14px;
    border-bottom: 1px solid rgb(78, 78, 78);
  }
}
</style>
